import { Styles, css, extractTransition, verticalScrollCss, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: flex;
    flex-direction: column;
    max-height: 100%;
    padding-bottom: 8px;
  `,
  header: css`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0px 0px 22px;
  `,
  createChatButton: ({ theme }) => css`
    display: flex;
    gap: 4px;
    align-items: center;
    padding: 4px 8px 4px 4px;
    border-radius: 16px;
    cursor: pointer;
    user-select: none;

    ${extractTransition((f) => f.cubic, { property: 'background-color', duration: 220 })}

    &:hover {
      background-color: ${theme.colors.neutral.variant[10]};
    }
  `,
  fetchNextPageContainer: css`
    display: flex;
    flex-direction: column;
  `,
  noDataFound: css`
    display: flex;
    width: 300px;
    height: 40px;
    align-items: center;
    justify-content: center;
  `,
  listContainer: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    min-height: 0;
    max-height: 100%;
    overflow-y: scroll;

    ${verticalScrollCss(theme)}
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
